import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretDownFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9.099,2.5H2.901c-.554,0-1.061.303-1.322.792-.262.488-.233,1.079.074,1.54l3.099,4.648c.279.418.745.668,1.248.668s.969-.25,1.248-.668l3.099-4.648c.308-.461.336-1.051.074-1.54-.262-.489-.769-.792-1.322-.792Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCaretDownFill12.js.map